import {
    LandingPage,
    LandingPagePayload,
    LandingPageUrl,
    LandingPageTypeEnum
} from '@dev/ee-api/ee-api-models';
import { LandingPageSubdomainModel } from '@/store/landingPageSubdomain/types';
import { request } from './request';

export const loadLandings = (type: LandingPageTypeEnum, limit?: number, offset?: number): Promise<LandingPage[]> => {
    const { Landings } = request();
    return Landings.landingsListGet(type, limit, offset).then((resp): LandingPage[] => resp.data);
};

export const loadLanding = (name: string, isPublic: boolean): Promise<LandingPage> => {
    const { Landings } = request();
    return Landings.landingsGet(name, isPublic).then((resp): LandingPage => resp.data);
};

export const saveLanding = (landing: LandingPagePayload, name?: string): Promise<LandingPage> => {
    const { Landings } = request();

    if (name) {
        return Landings.landingsByNamePatch(name, landing).then((resp): LandingPage => resp.data);
    }

    return Landings.landingsPost(landing).then((resp): LandingPage => resp.data);
};

export const addLandingPageSubdomainApi = (landingPageUrl: LandingPageUrl) => {
    const { Landings } = request();
    return Landings.landingsSubdomainPost(landingPageUrl).then((resp) => resp.data) as Promise<LandingPageSubdomainModel>;
    
};
export const addLandingPageAccountSubdomainApi = (subdomain: string) => {
    const { Landings } = request();
    return Landings.landingsSubdomainAccountPost(subdomain).then((resp) => resp.data) as Promise<LandingPageSubdomainModel>;
    
};
export const updateLandingPageAccountSubdomainApi = (subdomain: string) => {
    const { Landings } = request();
    return Landings.landingsSubdomainAccountPut(subdomain).then((resp) => resp.data) as Promise<LandingPageSubdomainModel>;
    
};

export const updateLandingPageSubdomainApi = (landingPageUrl: LandingPageUrl)=> {
    const { Landings } = request();
    return Landings.landingsSubdomainPatch(landingPageUrl).then((resp) => resp.data) as Promise<LandingPageSubdomainModel>;
    
};

export const getLandingPageSubdomainApi = (landingPageId: number): Promise<object> => {
    const { Landings } = request();
    return Landings.landingsSubdomainGet(landingPageId).then((resp) => resp.data);
};

